const HeroSection = () => {
    return (
      <section style={styles.heroSection}>
        <div style={styles.textBlock}>
          <h1 style={styles.title}>Creating new expansion opportunities by embracing innovation.</h1>
          <p style={styles.subtitle}>
           <span style={styles.highlight}>Incogify</span> deliver intelligent IT solutions that drive your journey to success.
          </p>
        </div>
        <div style={styles.animationBlock}>
          <svg
            viewBox="0 0 600 600"
            xmlns="http://www.w3.org/2000/svg"
            style={styles.svg}
          >
            <path
              d="M300,50 C400,50 500,150 500,250 C500,350 400,450 300,450 C200,450 100,350 100,250 C100,150 200,50 300,50 Z"
              stroke=" #28f168"
              strokeWidth="4"
              fill="none"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 300 250"
                to="360 300 250"
                dur="10s"
                repeatCount="indefinite"
              />
            </path>
            <circle cx="300" cy="250" r="50" fill=" #28f168">
              <animate
                attributeName="r"
                from="50"
                to="100"
                dur="2s"
                repeatCount="indefinite"
                values="50;80;50"
                keyTimes="0;0.5;1"
              />
            </circle>
          </svg>
        </div>
      </section>
    );
  };
  
  const styles = {
    heroSection: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: '#000',
      color: '#fff',
      padding: '80px 20px',
    },
    textBlock: {
      maxWidth: '50%',
    },
    title: {
      fontSize: '3rem',
      fontWeight: 'bold',
    },
    subtitle: {
      fontSize: '1.5rem',
      marginTop: '20px',
    },
    highlight: {
      color: ' #28f168',
      fontWeight: 'bold',
    },
    animationBlock: {
      width: '50%',
      display: 'flex',
      justifyContent: 'center',
    },
    svg: {
      width: '100%',
      maxWidth: '400px',
    },
  };
  
  export default HeroSection;
  